/**
 * 이메일 유효성 검증
 * @param value string
 * @return boolean
 */
export default function validateEmail(value: string) {
  if (!value) {
    return false;
  }

  return !!value.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
}
